import * as actions from './slice'
import { stackAlert } from '../toast/helpers'
import { bindActionPayload } from '../util'

export const togglePlaylistContentRead = {
  eventName: 'playlistContentToggleReadStatus',
  onSuccess: {
    action: actions.togglePlaylistContentRead,
    redux: true
  },
  // Only the success action cleared the indicator, so a failed toggle left the
  // button spinning for the rest of the session — the error toast was the sole
  // sign anything had happened, and the button never came back.
  onError: [
    {
      action: bindActionPayload(actions.setLoadingIndicator, {
        visible: false
      }),
      redux: true
    },
    {
      action: stackAlert('Unable to update content read', 'error'),
      redux: true
    }
  ]
}

export const getPlaylistsProgress = {
  eventName: 'playlistGetProgress',
  onSuccess: {
    action: actions.setProgress,
    redux: true
  },
  onError: {
    action: stackAlert('Unable to fetch playlist progress', 'error'),
    redux: true
  }
}
